import { useStores } from "../..";
import useAuthCheck from "./UseAuthCheck";

let AuthProvider: React.FC<{ children: React.ReactElement }> = (
  ({ children }) => {
    let appStore = useStores();
    useAuthCheck(appStore.lastRequestTime);
    return <>{children}</>;
  }
);

export default AuthProvider;
